<script>
export default {
    name: 'KnowledgeUseData',
    data() {
        return {
            tableData: [],
            val: "",
            selectValue: "",
            dateValue: "",
            daysList: ["昨天", "近7天", "近15天"],
            active: 0,
            options: []
        }
    }
}
</script>

<template>
    <div class="knowledge-container">
        <div class="knowledge-options">
            <el-input v-model="val" prefix-icon="el-icon-search" placeholder="搜索问题" style="width: 200px;" />
            <span>知识分类</span>
            <el-select v-model="selectValue" placeholder="请选择" style="width: 200px;">
                <el-option v-for="(item, key) in options" :label="item" :key="key" :value="item"></el-option>
            </el-select>
            <el-date-picker
                v-model="dateValue"
                type="daterange"
                clearable
                range-separator="～"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <div class="day-list">
                <div class="day-one" v-for="(item, key) in daysList"
                     :key="key" :class="active === key ? 'active' : ''">
                    {{item}}
                </div>
            </div>
        </div>
        <div class="knowledge-table">
            <el-table :data="tableData" header-cell-class-name="custom-header">
                <el-table-column label="问题" />
                <el-table-column label="答案" />
                <el-table-column label="知识分类" />
                <el-table-column label="总命中数" sortable />
                <el-table-column label="直接命中数" sortable />
                <el-table-column label="直接命中率" sortable />
                <el-table-column label="直接命中转人工率" sortable />
                <template slot="empty">
                    <div class="no-data" style="display: flex;justify-content: center;align-items: center;flex-direction: column;padding: 50px 0;">
                        <img style="width: 150px;height: 150px;" :src="require('@/assets/images/training/scene/noResult.svg')" alt="">
                        <span>暂无数据</span>
                    </div>
                </template>
            </el-table>
        </div>
    </div>
</template>

<style scoped lang="scss">
.knowledge-container {
    &, & * {
        box-sizing: border-box;
    }
    width: 100%;
    height: 100%;
    background: #FFF;
    padding: 16px 0;
    .knowledge-options {
        margin-bottom: 24px;
        display: flex;
        gap: 8px;
        justify-content: flex-start;
        align-items: center;
        .day-list {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 8px;
            .day-one {
                width: 88px;
                height: 32px;
                line-height: 32px;
                color: #161823bf;
                text-align: center;
                border: 1px solid #16182329;
                cursor: pointer;
                border-radius: 4px;
                &.active {
                    border-color: #2a55e5;
                    color: #2a55e5;
                }
            }
        }
    }
    .knowledge-table {
        &:deep(.el-table) {
            .custom-header {
                background: #f5f7fa;
                color: #161823;
            }
        }
    }
}

</style>
